import React, { useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { setLoading } from '@/store/slices/appSlice';
import { useTypedDispatch } from '@/store/hooks';
import { Box, Button, Flex, Title, Image, Text } from '@mantine/core';
import { ContactBoxes } from '@/components/partials/contactBoxes/ContactBoxes';
import { useContent } from '@/providers/ContentProvider';
import styles from './ErrorPage.module.scss';

interface Props {
	httpCode: string;
}

const baseSlug = 'errorPage.';

export const ErrorPage: React.FC<Props> = ({ httpCode }) => {
	const { pathname } = useLocation();

	const { getContent } = useContent();

	useEffect(() => {
		const nav = document.getElementById('navbar'),
			footer = document.querySelector('footer');
		nav?.classList.add('hidden');
		footer?.classList.add('hidden');
		return () => {
			nav?.classList.remove('hidden');
			footer?.classList.remove('hidden');
		};
	}, []);

	const navigate = useNavigate();
	const dispatch = useTypedDispatch();

	const handleNavigate = () => {
		dispatch(setLoading(false));
		navigate('/');
	};

	const errorMessage = useMemo(() => {
		switch (httpCode) {
			case '404':
				return getContent(`${baseSlug}errorNotResourceFound`);
			case '':
				return getContent(`${baseSlug}errorNotPageFound`);
			default:
				return getContent(`${baseSlug}errorServer`);
		}
	}, [httpCode]);

	return (
		<Flex
			gap="xl"
			className={styles.container}
			justify="center"
			bg="gray.0"
			p="xl"
		>
			<Box maw={530}>
				<Title order={1} mb="lg">
					{httpCode || '404'}
				</Title>
				<Title order={3} mb="sm">
					{getContent(`${baseSlug}title`)}
				</Title>
				<Text size="md" c="dimmed" mb="md">
					{errorMessage}
				</Text>
				<ContactBoxes />
				<Button onClick={handleNavigate}>
					{getContent(`${baseSlug}goBackToMainPageButton`)}
				</Button>
			</Box>
			<Image
				src={''}
				w={500}
				display={{
					base: 'none',
					lg: 'block',
				}}
			/>
		</Flex>
	);
};
